import {
  SET_CONNECTION,
  SET_COUNT_OF_UNREAD_MESSAGES,
  NEW_NOTIFICATION
} from '../types';

const INITIAL_STATE = {
  notification: '',
  totalCount: 0,
  connection: null
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case NEW_NOTIFICATION:
      return {
        ...state,
        notification: payload
      };
    case SET_CONNECTION:
      return {
        ...state,
        connection: payload
      };
    case SET_COUNT_OF_UNREAD_MESSAGES:
      return {
        ...state,
        totalCount: payload
      };
    default:
      return state;
  }
};
